import sistemaStore from "@/store/sistema";

const versaoDB = 2;
const nameDB = sistemaStore.getters.isModeDevelopment()
  ? "nutricao-animal-teste"
  : "nutricao-animal";

export async function conexaoDB() {
  const dbExist = await existeBancoDados();
  if (!dbExist) {
    return null;
  }

  return new Promise((resolve) => {
    const request = indexedDB.open(nameDB, versaoDB);
    request.onsuccess = (event) => {
      resolve(event.target.result);
    };
  });
}

export async function existeBancoDados() {
  try {
    var dbExists = true;
    var request = indexedDB.open(nameDB);
    request.onupgradeneeded = function (e) {
      e.target.transaction.abort();
      dbExists = false;
    };
    return dbExists;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function iniciarBancoDados() {
  const conn = indexedDB.open(nameDB, versaoDB);
  return new Promise((resolve) => {
    (conn.onupgradeneeded = (event) => {
      const db = event.target.result;      
      if (event.oldVersion < 1) {
        db.createObjectStore("usuarios-relacionados", { autoIncrement: true });
        db.createObjectStore("usuario-logado", { autoIncrement: true });
        db.createObjectStore("atalhos-iniciais", { autoIncrement: true });
        db.createObjectStore("clientes", { autoIncrement: true });
        db.createObjectStore("produtos", { autoIncrement: true });
        db.createObjectStore("config-pedidos", { autoIncrement: true });
        db.createObjectStore("produtos-pendentes", { autoIncrement: true });
        db.createObjectStore("pedidos", { autoIncrement: true });
        db.createObjectStore("sincronizacoes", { autoIncrement: true });
        db.createObjectStore("base", { autoIncrement: true });
      }

      /*Exemplo do que fazer nas próx. atualizações de DB*/
      if (event.oldVersion < 2) {
        db.deleteObjectStore("usuarios-relacionados", { autoIncrement: true });
        db.deleteObjectStore("usuario-logado", { autoIncrement: true });
        db.deleteObjectStore("atalhos-iniciais", { autoIncrement: true });
        db.deleteObjectStore("clientes", { autoIncrement: true });
        db.deleteObjectStore("produtos", { autoIncrement: true });
        db.deleteObjectStore("config-pedidos", { autoIncrement: true });
        db.deleteObjectStore("produtos-pendentes", { autoIncrement: true });
        db.deleteObjectStore("pedidos", { autoIncrement: true });
        db.deleteObjectStore("sincronizacoes", { autoIncrement: true });
        db.deleteObjectStore("base", { autoIncrement: true });

        db.createObjectStore("usuarios-relacionados", { autoIncrement: true });
        db.createObjectStore("usuario-logado", { autoIncrement: true });
        db.createObjectStore("atalhos-iniciais", { autoIncrement: true });
        db.createObjectStore("clientes", { autoIncrement: true });
        db.createObjectStore("produtos", { autoIncrement: true });
        db.createObjectStore("config-pedidos", { autoIncrement: true });
        db.createObjectStore("produtos-pendentes", { autoIncrement: true });
        db.createObjectStore("pedidos", { autoIncrement: true });
        db.createObjectStore("sincronizacoes", { autoIncrement: true });
        db.createObjectStore("base", { autoIncrement: true });
        db.createObjectStore("insumos", { autoIncrement: true });        
        db.createObjectStore("pedidos-insumos", { autoIncrement: true });        
      }

      resolve(true);
    }),
      (conn.onsuccess = () => {
        resolve(true);
      });
  });
}

export default {
  iniciarBancoDados,
  conexaoDB,
  existeBancoDados,
};
